import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import menuData from './Menu/';

export default function MenuTabs() {
  const { i18n } = useTranslation();
  const sections = ['Appetizers', 'Sandwiches', 'Dishes', 'Drinks']; // fixed order
  const [menuSections, setMenuSections] = useState({});
  const [activeTab, setActiveTab] = useState(sections[0]); // Appetizers first
  const isArabic = i18n.language === 'ar';

  // Simple translations
  const labels = {
    ingredients: {
      en: "Ingredients",
      pl: "Składniki",
      ar: "المكونات",
    },
    price: {
      en: "Price",
      pl: "Cena",
      ar: "السعر",
    },
    noItems: {
      en: "No menu items found.",
      pl: "Brak pozycji w menu.",
      ar: "لا توجد عناصر في القائمة.",
    }
  };

  useEffect(() => {
    const loadedSections = {};
    sections.forEach(sec => {
      loadedSections[sec] = menuData[sec]?.[i18n.language]?.items || [];
    });
    setMenuSections(loadedSections);
  }, [sections, i18n.language]);

  return (
    <section 
      className={`max-w-[1200px] mx-auto lg:px-0 px-4 py-10 ${isArabic ? 'arabic-font text-right' : 'falafel-font text-left'}`} 
      dir={isArabic ? 'rtl' : 'ltr'}
    >
      {/* Tabs header */}
      <div className="flex border-b mb-6">
        {sections.map(sec => (
          <button
            key={sec}
            onClick={() => setActiveTab(sec)}
            className={`px-6 py-2 text-lg font-semibold transition-colors ${
              activeTab === sec
                ? "border-b-4 border-[#DC143C] text-[#DC143C]"
                : "text-gray-500 hover:text-[#DC143C]"
            }`}
          >
            {menuData[sec]?.[i18n.language]?.subject || sec}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div>
        {(!menuSections[activeTab] || !menuSections[activeTab].length) ? (
          <p className="text-center py-6">
            {labels.noItems[i18n.language] || labels.noItems.en}
          </p>
        ) : (
          <ul className="space-y-6">
            {menuSections[activeTab].map((item, index) => (
              <li key={index} className="border-b pb-4">
                <h4 className="font-bold text-2xl mb-2">
                  <span
                    className={`inline-flex items-center justify-center px-3 aspect-square rounded-full bg-[#DC143C] text-white ${
                      isArabic ? 'ml-3' : 'mr-3'
                    }`}
                  >
                    {item.ID}
                  </span>
                  {item.name}
                </h4>

                <p>{item.description}</p>
                {item.ingredients && (
                  <p className="text-gray-700 mb-2">
                    <strong>{labels.ingredients[i18n.language]}:</strong>{" "}
                    {Array.isArray(item.ingredients) 
                      ? item.ingredients.join(', ') 
                      : item.ingredients}
                  </p>
                )}
                
                {item.price && (
                  <p className="text-[#DC143C] text-xl">
                    <strong>{labels.price[i18n.language]}:</strong> {item.price} zł
                  </p>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
